var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('Topbar',{ref:"con1",on:{"inid":_vm.inid}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('Bottombar',{ref:"con2"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }